module.exports = __webpack_public_path__ + "img/illustration.59138667.svg";